// extracted by mini-css-extract-plugin
module.exports = {"panelSpeed":"270ms","panelTimingFunction":"ease-in-out","container":"SystemUserGroupCount__container","visible":"SystemUserGroupCount__visible"};